import { render, staticRenderFns } from "./BudgetRequetsAllFile.vue?vue&type=template&id=65e2d01b&"
import script from "./BudgetRequetsAllFile.vue?vue&type=script&lang=ts&"
export * from "./BudgetRequetsAllFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports